import React, { createContext, useReducer } from 'react'
import { userReducer } from './reducer'
import actions from './actions'

const initialUserState = {
  token: null,
  user: {
    banned: false,
    comments: [],
    createdAt: '',
    email: '',
    emailVerified: false,
    followers: [],
    following: [],
    fullName: '',
    isOnline: false,
    likes: [],
    messages: [],
    notifications: [],
    posts: [],
    role: '',
    updatedAt: '',
    username: '',
    __v: 0,
    _id: '',
  },
}

export const UserContext = createContext()

const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialUserState)

  const {
    handleLogin,
    handleLogout,
    handleSignup,
    handleGetUser,
    handleGetUserPost,
  } = actions(dispatch)

  return (
    <UserContext.Provider
      value={{
        state,
        handleLogin,
        handleLogout,
        handleSignup,
        handleGetUser,
        handleGetUserPost,
      }}>
      {children}
    </UserContext.Provider>
  )
}

export default UserProvider
